import React from "react";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";

function Contact() {
  return (
    <div className="contact">
      <div className="contact__container">
        <h1>Kontakta Oss</h1>
        
        <div className="contact__content">
          <div className="contact__info">
            <h2>Kontaktinformation</h2>
            
            <div className="contact__item">
              <FontAwesomeIcon icon={faEnvelope} className="contact__icon" />
              <div>
                <h3>E-post</h3>
                <p>Skicka oss ett meddelande</p>
                <a href="mailto:info@isaksbilar.se">info@isaksbilar.se</a>
              </div>
            </div>
            
            <div className="contact__item">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="contact__icon" />
              <div>
                <h3>Besöksadress</h3>
                <p>Kom och träffa oss</p>
                <span>Bilgatan 123<br />123 45 Stockholm</span>
              </div>
            </div>
            
            <div className="contact__item">
              <FontAwesomeIcon icon={faClock} className="contact__icon" />
              <div>
                <h3>Öppettider</h3>
                <p>Vi är här för dig</p>
                <span>
                  Mån-Fre: 08:00-18:00<br />
                  Lör: 09:00-15:00<br />
                  Sön: Stängt
                </span>
              </div>
            </div>
          </div>
          
          <div className="contact__form">
            <h2>Skicka oss ett meddelande</h2>
            <form>
              <div className="form__group">
                <label htmlFor="name">Namn *</label>
                <input type="text" id="name" name="name" required />
              </div>
              
              <div className="form__group">
                <label htmlFor="email">E-post *</label>
                <input type="email" id="email" name="email" required />
              </div>
              
              <div className="form__group">
                <label htmlFor="subject">Ämne *</label>
                <select id="subject" name="subject" required>
                  <option value="">Välj ämne</option>
                  <option value="bilhandel">Bilhandel</option>
                  <option value="service">Service</option>
                  <option value="finansiering">Finansiering</option>
                  <option value="övrigt">Övrigt</option>
                </select>
              </div>
              
              <div className="form__group">
                <label htmlFor="message">Meddelande *</label>
                <textarea id="message" name="message" rows="5" required></textarea>
              </div>
              
              <button type="submit" className="contact__button">
                Skicka meddelande
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
